module.exports = "<div class=calendar-forms-wrap> <header> <div class=nav_nwe> {{#each tableNames}} <div class=tableName data-id={{tableId}}> <i class=left></i>{{tableName}}<i class=right></i> </div> {{/each}} </div> <div class=tabBtn> <div class=sort-wrap><i class=sort></i>排序</div> <div class=saveSort><i class=preserve></i>保存</div> </div> </header> <content> </content> <footer><button class=submit>提交</button></footer> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendarOpenForms/formsBanner.html
// module id = 4956
// module chunks = 50